import styled from 'styled-components';

export const Container = styled.div`
  -webkit-box-flex: 0;
  flex: 0 1 30px;
  position: relative;
  z-index: 2;
  background: rgba(0, 0, 0, 0.2);
  color: #000000;
  text-transform: uppercase;
  text-align: left;
  padding: 10px 10px 10px 50px;
  & h1,
  h2 {
    font-weight: normal;
    font-size: 0.8em;
    margin: 0;
    padding: 0;
  }
  & h2 {
    display: none;
    font-size: 0.6em;
    letter-spacing: 1px;
  }
  & figure {
    background-color: black;
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 9px;
    border-radius: 30px;
    width: 30px;
    height: 30px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 2px solid rgba(255, 255, 255, 0.24);
    & img {
      width: 100%;
      height: auto;
      margin: -2px -1px;
    }
  }
`;


export const MonitorOnly = styled.div`
  position: absolute;
  bottom: 5px;
  right: 50px;
  & input {
    margin-right: 5px;
  }
`;

export const Title = styled.h1``;
export const SubTitle = styled.h2``;
